import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks/redux';
import {
  getNewsfeeds,
  getNewsfeedsClear,
  getNewsfeedsIdle,
} from 'store/ducks/newsfeeds/actions';
import { newsfeedsSelector } from 'store/ducks/newsfeeds/selectors';

export function useAuthorPosts(author: string) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const status = useAppSelector(state => state.newsfeeds.status);
  const title = useAppSelector(state => state.newsfeeds.title);
  const newsfeeds = useAppSelector(newsfeedsSelector);
  const paginate = useAppSelector(state => state.newsfeeds.paginate);

  useEffect(() => {
    if (status === 'SUCCESS') dispatch(getNewsfeedsIdle());
  }, [dispatch, status]);

  useEffect(() => {
    setPage(0);
    dispatch(getNewsfeedsClear());
    // Omit page for the first 18-item request. The API maps subsequent
    // local pages 1, 2, ... to legacy pages 4, 5, ... with six items each.
    dispatch(getNewsfeeds({ taxonomy: author, type: 'author' }));
  }, [dispatch, author]);

  useEffect(
    () => () => {
      dispatch(getNewsfeedsClear());
    },
    [dispatch]
  );

  const loadMore = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (status !== 'IDLE') return;
    setPage(page + 1);
    dispatch(
      getNewsfeeds({
        taxonomy: author || '0',
        type: 'author',
        page: page + 1,
      })
    );
  };

  return { status, title, newsfeeds, paginate, loadMore };
}
